import { fuego } from '@store/firebase';
import { saveAndGetImgURL } from '@store/firebase/storage';

export async function addCoupleAndGetID({ collectionPath, data }) {
  const ref = fuego.db.collection(collectionPath);

  const docId = await ref
    .add({
      ...data,
      createdAt: new Date(),
      editedAt: new Date(),
    })
    .then((res) => res.id)
    .catch((err) => console.log(err.message));


  return docId;
}

type Props = {
  collectionPath: string;
  docId: string;
  file: File;
  key:
    | 'leftHeadImgURL'
    | 'leftBodyImgURL'
    | 'rightHeadImgURL'
    | 'rightBodyImgURL';
};

export async function addCoupleHeadBodyImgAndGetURL({
  collectionPath,
  docId,
  file,
  key,
}: Props) {
  const ref = fuego.db.collection(collectionPath);

  const imgURL = await saveAndGetImgURL(
    `${collectionPath}/${docId}/${key}`,
    file,
  );
  // 바로 저장해서 데이터를 바꾸지 않고, url만 반환
  // await ref.doc(docId).set({ [key]: imgURL }, { merge: true });
  return imgURL;
}
